<script setup lang="ts">
defineProps<{ count: number; channelId: number }>()
</script>

<template>
  <span
    v-if="count > 0"
    class="shrink-0 rounded-full bg-brand-primary/30 px-1.5 text-[11px] text-white"
    :data-testid="`channel-unread-${channelId}`"
    :aria-label="`${count} unread`"
    >{{ count }}</span
  >
</template>
